import React from 'react'

export interface FirstTimeLogoProps extends React.SVGAttributes<SVGElement> {}

export const FirstTimeLogo: React.SFC<FirstTimeLogoProps> = ({...props}) => (
  <svg viewBox="0 0 278 154" width="278" height="154" {...props}>
    <defs>
      <clipPath id="a">
        <path
          d="M201,122.41c0,3.64-2.69,6.59-6,6.59H82c-3.31,0-6-3-6-6.59V35.65c0-3.64,2.69-6.59,6-6.59H195c3.31,0,6,3,6,6.59Z"
          fill="#eaf7ff"
        />
      </clipPath>
      <linearGradient id="b" x1="190.44" y1="87.28" x2="194.81" y2="87.28" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <linearGradient id="c" x1="194.81" y1="87.28" x2="199.18" y2="87.28" />
      <linearGradient id="d" x1="199.18" y1="87.28" x2="203.56" y2="87.28" />
      <linearGradient id="e" x1="203.56" y1="87.28" x2="207.93" y2="87.28" />
      <linearGradient id="f" x1="207.93" y1="87.28" x2="212.3" y2="87.28" />
      <linearGradient id="g" x1="212.3" y1="87.28" x2="216.68" y2="87.28" />
      <linearGradient id="h" x1="196.48" y1="76.92" x2="198.32" y2="76.92" />
      <linearGradient id="i" x1="202.37" y1="76.79" x2="204.21" y2="76.79" />
      <linearGradient id="j" x1="208.11" y1="76.66" x2="209.94" y2="76.66" />
      <clipPath id="k">
        <path d="M131.4,73.26a5.69,5.69,0,1,0,5.68,5.7,5.7,5.7,0,0,0-5.68-5.7Z" fill="none" />
      </clipPath>
      <clipPath id="l">
        <path
          d="M138.24,98.66a8.48,8.48,0,0,0,8.49-8.46c0-5.63-2.83-5.32-1-10.85l-14.89,0c1.79,5.53-1,5.22-1.06,10.85a8.48,8.48,0,0,0,8.46,8.49"
          fill="#a7e3fa"
        />
      </clipPath>
      <clipPath id="m">
        <circle cx="20.44" cy="88.64" r="18.5" fill="#a7e3fa" />
      </clipPath>
      <clipPath id="n">
        <path
          d="M15.4,95.32a5.45,5.45,0,0,0,1.76-1.61l1.47,1.11a.29.29,0,0,0,.49,0l.75-2.32a.28.28,0,0,0-.27-.41s-1.68,0-1.63-.18a5.32,5.32,0,0,0,.14-1.23,5.42,5.42,0,0,0-10.83,0,5.32,5.32,0,0,0,.14,1.23c.05.23-1.61.18-1.61.18a.28.28,0,0,0-.27.41l.75,2.32a.29.29,0,0,0,.49,0l1.46-1.1A5.45,5.45,0,0,0,10,95.32h0a5.43,5.43,0,0,0,.57.29l0,.69c-2.28.79-4.22,2.91-5.43,5.74-.85,2,.54.29.54,2.76l16,4c0-6-2.88-11.18-6.76-12.53l0-.48a6.44,6.44,0,0,0,.56-.39Z"
          fill="#d1edff"
        />
      </clipPath>
    </defs>
    <title>58_AppSettings_FirstTime_v7</title>
    <ellipse cx="138.19" cy="148.06" rx="63.01" ry="4.1" fill="#d3edff" opacity="0.95" />
    <path
      d="M201,122.41c0,3.64-2.69,6.59-6,6.59H82c-3.31,0-6-3-6-6.59V35.65c0-3.64,2.69-6.59,6-6.59H195c3.31,0,6,3,6,6.59Z"
      fill="#eaf7ff"
    />
    <g clipPath="url(#a)">
      <rect x="75.42" y="28.84" width="128.52" height="21.28" fill="#5fcef5" />
    </g>
    <circle cx="89.23" cy="36.47" r="4.24" fill="#4eb7f5" />
    <circle cx="113.59" cy="36.47" r="4.24" fill="#4eb7f5" />
    <circle cx="137.95" cy="36.47" r="4.24" fill="#4eb7f5" />
    <circle cx="162.32" cy="36.47" r="4.24" fill="#4eb7f5" />
    <circle cx="186.68" cy="36.47" r="4.24" fill="#4eb7f5" />
    <rect x="184.56" y="23.06" width="4.24" height="15.54" rx="1.86" ry="1.86" fill="#a7e3fa" />
    <rect x="111.47" y="23.06" width="4.24" height="15.54" rx="1.86" ry="1.86" fill="#a7e3fa" />
    <rect x="160.2" y="23.06" width="4.24" height="15.54" rx="1.86" ry="1.86" fill="#a7e3fa" />
    <rect x="135.84" y="23.06" width="4.24" height="15.54" rx="1.86" ry="1.86" fill="#a7e3fa" />
    <rect x="87.11" y="23.06" width="4.24" height="15.54" rx="1.86" ry="1.86" fill="#a7e3fa" />
    <circle cx="73.06" cy="88.64" r="23" fill="#5fcef5" />
    <rect
      x="60.84"
      y="90.42"
      width="26.04"
      height="1.86"
      rx="0.93"
      ry="0.93"
      transform="translate(-42.96 78.98) rotate(-45)"
      fill="#b1ddf8"
    />
    <rect
      x="58.93"
      y="90.47"
      width="26.04"
      height="1.86"
      rx="0.93"
      ry="0.93"
      transform="translate(58.2 206.9) rotate(-135)"
      fill="#b1ddf8"
    />
    <rect
      x="59.73"
      y="87.19"
      width="26.04"
      height="1.86"
      rx="0.93"
      ry="0.93"
      transform="translate(-15.37 160.87) rotate(-90)"
      fill="#b1ddf8"
    />
    <rect x="60.35" y="76.96" width="24.8" height="16.43" fill="#eaf7ff" />
    <rect x="75.7" y="82.23" width="5.58" height="1.08" fill="#7fccf7" />
    <rect x="75.7" y="84.68" width="5.58" height="1.08" fill="#7fccf7" />
    <path
      d="M68.71,81.35a4.4,4.4,0,0,1,4.4,4.53,4.45,4.45,0,0,1-4.28,4.28,4.4,4.4,0,0,1-4.53-4.4h4.4Z"
      fill="#7fccf7"
    />
    <path d="M67.74,84.77v-4.4a4.4,4.4,0,0,0-4.4,4.4Z" fill="#7fccf7" />
    <circle cx="257.69" cy="88.64" r="18.5" fill="#a7e3fa" />
    <path
      d="M257.87,79.24a8,8,0,0,0-7.95,7.95c0,5.11,5.72,11.48,6.62,12.45.37.4.68.8,1.32.8s1-.39,1.32-.8c.9-1,6.62-7.35,6.62-12.45A8,8,0,0,0,257.87,79.24Z"
      fill="#e7f6ff"
    />
    <circle cx="257.87" cy="87.19" r="3.5" fill="#a7e3fa" />
    <circle cx="257.87" cy="87.19" r="2.65" fill="#a7e3fa" />
    <circle cx="203.56" cy="88.64" r="23" fill="#5fcef5" />
    <rect x="190.44" y="85.09" width="26.24" height="13.92" rx="0.96" ry="0.96" fill="#d3edff" />
    <path
      d="M190.44,92.85h26.24a0,0,0,0,1,0,0v5.2a1,1,0,0,1-1,1H191.4a1,1,0,0,1-1-1v-5.2A0,0,0,0,1,190.44,92.85Z"
      fill="#a7e3fa"
    />
    <circle cx="192.62" cy="87.28" r="2.19" fill="url(#b)" />
    <circle cx="197" cy="87.28" r="2.19" fill="url(#c)" />
    <circle cx="201.37" cy="87.28" r="2.19" fill="url(#d)" />
    <circle cx="205.74" cy="87.28" r="2.19" fill="url(#e)" />
    <circle cx="210.12" cy="87.28" r="2.19" fill="url(#f)" />
    <rect x="196.6" y="78.89" width="1.61" height="7.23" rx="0.75" ry="0.75" fill="#a7e3fa" />
    <rect x="202.49" y="78.89" width="1.61" height="7.23" rx="0.75" ry="0.75" fill="#a7e3fa" />
    <rect x="208.38" y="78.89" width="1.61" height="7.23" rx="0.75" ry="0.75" fill="#a7e3fa" />
    <circle cx="214.49" cy="87.28" r="2.19" fill="url(#g)" />
    <path
      d="M191.4,85.09h24.32a1,1,0,0,1,1,1v1.23a0,0,0,0,1,0,0H190.44a0,0,0,0,1,0,0V86.05A1,1,0,0,1,191.4,85.09Z"
      fill="#fff"
    />
    <path d="M198.32,77.21a.92.92,0,0,1-1.84,0c0-.51.92-1.49.92-1.49S198.32,76.7,198.32,77.21Z" fill="url(#h)" />
    <path d="M204.21,77.08a.92.92,0,0,1-1.84,0c0-.51.92-1.49.92-1.49S204.21,76.57,204.21,77.08Z" fill="url(#i)" />
    <path d="M209.94,76.94a.92.92,0,1,1-1.84,0c0-.51.92-1.49.92-1.49S209.94,76.44,209.94,76.94Z" fill="url(#j)" />
    <polygon
      points="41.5 111.64 44.26 110.8 45.1 108.05 45.94 110.8 48.69 111.64 45.94 112.49 45.1 115.24 44.26 112.49 41.5 111.64"
      fill="#a7e3fa"
    />
    <polygon
      points="50.61 29.06 55.37 27.6 56.82 22.84 58.28 27.6 63.03 29.06 58.28 30.51 56.82 35.27 55.37 30.51 50.61 29.06"
      fill="#a7e3fa"
    />
    <rect
      x="60.62"
      y="48.94"
      width="1.64"
      height="4.92"
      transform="translate(-10.67 86.27) rotate(-65.72)"
      fill="#a7e3fa"
    />
    <rect
      x="28.9"
      y="1.52"
      width="4.76"
      height="14.27"
      transform="translate(1.64 21.88) rotate(-39.52)"
      fill="#a7e3fa"
    />
    <rect
      x="50.47"
      y="120.34"
      width="9.27"
      height="3.09"
      transform="translate(-42.75 30.69) rotate(-22.69)"
      fill="#a7e3fa"
    />
    <path
      d="M50.05,73.19a.5.5,0,0,1-.41-.78q.21-.3.38-.62a.5.5,0,0,1,.87.49q-.2.36-.43.7A.5.5,0,0,1,50.05,73.19Zm1.23-2.81h-.11a.5.5,0,0,1-.38-.6c.05-.24.09-.47.13-.71a.51.51,0,0,1,.56-.43.5.5,0,0,1,.43.56q-.05.41-.14.81A.5.5,0,0,1,51.29,70.38Zm.1-3.07a.5.5,0,0,1-.49-.42c0-.24-.09-.47-.15-.71a.5.5,0,1,1,1-.25q.1.4.17.8a.5.5,0,0,1-.42.57Zm-1.05-2.88a.5.5,0,0,1-.43-.24c-.12-.2-.26-.41-.4-.6a.5.5,0,0,1,.8-.59q.25.33.46.68a.5.5,0,0,1-.43.76Zm-17-.06a.5.5,0,0,1,0-1c.24,0,.48,0,.72-.07a.5.5,0,0,1,.15,1q-.41.06-.82.08Zm-2.3-.2h-.11q-.4-.09-.79-.22a.5.5,0,1,1,.32-.95c.23.08.46.14.7.2a.5.5,0,0,1-.11,1Zm5.28-.55a.5.5,0,0,1-.21-1q.33-.15.64-.34a.5.5,0,0,1,.51.86q-.36.21-.73.38A.5.5,0,0,1,36.33,63.61Zm-8.08-.7a.5.5,0,0,1-.29-.09q-.33-.23-.65-.5a.5.5,0,1,1,.65-.76,7.21,7.21,0,0,0,.57.44.5.5,0,0,1-.29.91Zm20-.77A.5.5,0,0,1,48,62q-.29-.22-.6-.41a.5.5,0,1,1,.52-.85q.35.21.68.46a.5.5,0,0,1-.3.9Zm-9.4-.26A.5.5,0,0,1,38.6,61q.34-.23.7-.43a.5.5,0,0,1,.48.88q-.32.17-.62.38A.5.5,0,0,1,38.88,61.88Zm6.65-1.1-.13,0q-.35-.1-.71-.16a.5.5,0,1,1,.17-1q.4.07.8.18a.5.5,0,0,1-.13,1ZM26.11,60.7a.5.5,0,0,1-.42-.23q-.23-.35-.41-.71a.5.5,0,1,1,.89-.46q.17.32.37.63a.5.5,0,0,1-.42.77Zm15.59,0a.5.5,0,0,1-.1-1c.27-.06.54-.1.81-.13a.5.5,0,0,1,.12,1q-.36,0-.72.12ZM25,57.85a.5.5,0,0,1-.49-.4q-.08-.4-.12-.81a.5.5,0,0,1,1-.1c0,.24.06.48.11.72a.5.5,0,0,1-.39.59Zm0-3.07h-.09a.5.5,0,0,1-.4-.58q.08-.4.19-.8a.5.5,0,0,1,1,.28q-.1.35-.17.7A.5.5,0,0,1,24.95,54.78Zm1.13-2.85a.5.5,0,0,1-.42-.77q.22-.34.47-.67a.5.5,0,1,1,.79.62c-.15.19-.29.39-.42.59A.5.5,0,0,1,26.07,51.93Zm2.1-2.21a.5.5,0,0,1-.35-.85q.26-.26.49-.53a.5.5,0,0,1,.77.64c-.17.21-.36.41-.55.61A.5.5,0,0,1,28.17,49.71Zm1.72-2.54a.5.5,0,0,1-.46-.7q.14-.33.25-.68a.5.5,0,0,1,1,.3q-.12.39-.29.77A.5.5,0,0,1,29.89,47.17Zm.65-3h0a.5.5,0,0,1-.49-.51v-.17c0-.18,0-.37,0-.55a.5.5,0,0,1,.46-.53.51.51,0,0,1,.53.46q0,.31,0,.62v.2A.5.5,0,0,1,30.54,44.17Zm-.51-3a.5.5,0,0,1-.47-.32c-.08-.22-.18-.45-.29-.66a.5.5,0,1,1,.9-.44q.18.37.32.75a.5.5,0,0,1-.47.68ZM11.56,39.76h0q-.41,0-.82-.08a.5.5,0,1,1,.14-1q.36.05.72.07a.5.5,0,0,1,0,1Zm2.3-.22a.5.5,0,0,1-.12-1q.35-.08.69-.2a.5.5,0,0,1,.33.95q-.39.13-.79.23ZM8.58,39a.5.5,0,0,1-.21,0c-.25-.11-.49-.24-.73-.38a.5.5,0,1,1,.5-.86c.21.12.43.23.64.33a.5.5,0,0,1-.21,1Zm19.84-.51a.5.5,0,0,1-.37-.16q-.25-.27-.51-.51a.5.5,0,1,1,.67-.74q.3.27.58.58a.5.5,0,0,1-.37.84Zm-11.77-.26a.5.5,0,0,1-.29-.91q.27-.19.52-.41l.38.33.32.38c-.24.2-.44.36-.64.5A.5.5,0,0,1,16.65,38.27Zm-10.57-1a.5.5,0,0,1-.36-.16l-.3-.33-.24-.29A.5.5,0,0,1,6,35.85l.21.26.26.29a.5.5,0,0,1-.36.84ZM26,36.7a.5.5,0,0,1-.22,0q-.33-.16-.67-.28a.5.5,0,1,1,.34-.94c.26.09.51.2.75.32a.5.5,0,0,1-.22,1Zm-6.74-.12a.5.5,0,0,1-.2-1q.38-.16.77-.29a.5.5,0,1,1,.31,1q-.34.11-.68.26A.5.5,0,0,1,19.22,36.57ZM23,35.92h0l-.5,0h-.22a.5.5,0,0,1,0-1h.25l.57,0a.5.5,0,0,1,0,1ZM4.43,34.66A.5.5,0,0,1,4,34.34q-.15-.38-.26-.78a.5.5,0,1,1,1-.28q.1.35.23.68a.5.5,0,0,1-.46.68Zm-.56-3h0a.5.5,0,0,1-.5-.5q0-.41,0-.82A.51.51,0,0,1,4,29.87a.5.5,0,0,1,.45.55q0,.36,0,.72A.5.5,0,0,1,3.86,31.64Zm.6-3a.49.49,0,0,1-.19,0A.5.5,0,0,1,4,27.94q.15-.38.34-.74a.5.5,0,1,1,.89.46c-.11.21-.21.43-.31.66A.5.5,0,0,1,4.46,28.63Zm1.68-2.57a.5.5,0,0,1-.36-.85q.28-.29.6-.56a.5.5,0,0,1,.65.76q-.28.24-.53.5A.5.5,0,0,1,6.14,26.06Z"
      fill="#4eb7f5"
    />
    <circle cx="138.07" cy="88.64" r="30.02" fill="#4eb7f5" />
    <path d="M131.4,73.26a5.69,5.69,0,1,0,5.68,5.7,5.7,5.7,0,0,0-5.68-5.7Z" fill="#d3edff" />
    <g clipPath="url(#k)">
      <rect
        x="131.14"
        y="73.4"
        width="1.37"
        height="13.84"
        transform="translate(-22.32 72.08) rotate(-28.29)"
        fill="#62ccf2"
      />
      <rect
        x="123.54"
        y="79.13"
        width="15.04"
        height="1.37"
        transform="matrix(0.49, -0.87, 0.87, 0.49, -2.35, 155.64)"
        fill="#62ccf2"
      />
      <rect
        x="131.15"
        y="72.5"
        width="1.37"
        height="13.32"
        transform="translate(52.44 210.85) rotate(-89.9)"
        fill="#62ccf2"
      />
    </g>
    <rect
      x="132.44"
      y="101.44"
      width="11.46"
      height="1.37"
      transform="translate(35.85 240.15) rotate(-89.92)"
      fill="#eaf7ff"
    />
    <rect
      x="137.39"
      y="103.6"
      width="1.37"
      height="8.5"
      transform="translate(29.99 245.75) rotate(-89.9)"
      fill="#eaf7ff"
    />
    <path
      d="M138.24,98.66a8.48,8.48,0,0,0,8.49-8.46c0-5.63-2.83-5.32-1-10.85l-14.89,0c1.79,5.53-1,5.22-1.06,10.85a8.48,8.48,0,0,0,8.46,8.49"
      fill="#a7e3fa"
    />
    <g clipPath="url(#l)">
      <rect
        x="131.51"
        y="70.52"
        width="12.8"
        height="22.61"
        transform="translate(55.85 219.59) rotate(-89.9)"
        fill="#eaf7ff"
      />
    </g>
    <polygon
      points="138.62 93.74 137.28 93.43 143.25 67.52 148.22 68.98 147.83 70.3 144.26 69.25 138.62 93.74"
      fill="#a7e3fa"
    />
    <ellipse
      cx="3.86"
      cy="58.62"
      rx="1.81"
      ry="1.8"
      transform="translate(-54.79 62.03) rotate(-89.56)"
      fill="#a7e3fa"
    />
    <ellipse
      cx="64.02"
      cy="8.66"
      rx="1.91"
      ry="1.89"
      transform="translate(54.87 72.61) rotate(-89.56)"
      fill="#a7e3fa"
    />
    <circle cx="20.44" cy="88.64" r="18.5" fill="#a7e3fa" />
    <g clipPath="url(#m)">
      <path
        d="M30.18,90.61a.47.47,0,0,1-.07-.85,5.2,5.2,0,0,0,2.39-4.63h-.23a4.75,4.75,0,0,1-4.34-2.83,5.18,5.18,0,0,1-5.77,4.22,5.25,5.25,0,0,0,2.47,3.39.5.5,0,0,1,0,.88C21.36,92.34,19,96.51,19,101.26c0,.34,0,1.13,0,1.13H36s0-.79,0-1.12C36,96.38,33.57,92.05,30.18,90.61Z"
        fill="#e7f6ff"
      />
      <path
        d="M27.94,82.32a4.75,4.75,0,0,0,4.34,2.83h.23c0-.15,0-.29,0-.45a5.25,5.25,0,1,0-10.31,1.85,5.18,5.18,0,0,0,5.77-4.22Z"
        fill="#5fcef5"
      />
      <path d="M20,99l-.93,3,2.55,6.79s8.94-3.77,9.69-3.77,4.71-4,4.71-4Z" fill="#e7f6ff" />
      <path
        d="M15.4,95.32a5.45,5.45,0,0,0,1.76-1.61l1.47,1.11a.29.29,0,0,0,.49,0l.75-2.32a.28.28,0,0,0-.27-.41s-1.68,0-1.63-.18a5.32,5.32,0,0,0,.14-1.23,5.42,5.42,0,0,0-10.83,0,5.32,5.32,0,0,0,.14,1.23c.05.23-1.61.18-1.61.18a.28.28,0,0,0-.27.41l.75,2.32a.29.29,0,0,0,.49,0l1.46-1.1A5.45,5.45,0,0,0,10,95.32h0a5.43,5.43,0,0,0,.57.29l0,.69c-2.28.79-4.22,2.91-5.43,5.74-.85,2,.54.29.54,2.76l16,4c0-6-2.88-11.18-6.76-12.53l0-.48a6.44,6.44,0,0,0,.56-.39Z"
        fill="#d1edff"
      />
      <g clipPath="url(#n)">
        <ellipse cx="19.31" cy="93.57" rx="2.64" ry="2.63" fill="#5fcef5" />
        <ellipse cx="6.78" cy="93.57" rx="2.64" ry="2.63" fill="#5fcef5" />
        <ellipse cx="12.7" cy="90.65" rx="5.42" ry="5.41" fill="#d1edff" />
        <ellipse cx="20.29" cy="83.71" rx="8.59" ry="8.57" fill="#5fcef5" />
        <ellipse cx="5.24" cy="84.83" rx="7.48" ry="7.46" fill="#5fcef5" />
      </g>
    </g>
    <polygon
      points="219.18 125.09 216.42 124.25 215.58 121.5 214.74 124.25 211.99 125.09 214.74 125.94 215.58 128.69 216.42 125.94 219.18 125.09"
      fill="#a7e3fa"
    />
    <polygon
      points="223.01 48.38 220.08 47.48 219.18 44.55 218.28 47.48 215.35 48.38 218.28 49.28 219.18 52.21 220.08 49.28 223.01 48.38"
      fill="#a7e3fa"
    />
    <rect
      x="215.55"
      y="25.99"
      width="5.07"
      height="1.69"
      transform="translate(8.26 92.05) rotate(-24.28)"
      fill="#a7e3fa"
    />
    <rect
      x="207.35"
      y="8.39"
      width="9.54"
      height="3.18"
      transform="translate(69.45 167.26) rotate(-50.48)"
      fill="#a7e3fa"
    />
    <rect
      x="238.51"
      y="110.61"
      width="3.09"
      height="9.27"
      transform="translate(41.14 292.27) rotate(-67.31)"
      fill="#a7e3fa"
    />
    <path
      d="M230,66.47h-.12a5.11,5.11,0,0,1-.81-.27.5.5,0,0,1,.4-.92,4,4,0,0,0,.65.22.5.5,0,0,1-.12,1Zm2.29,0a.5.5,0,0,1-.13-1,4,4,0,0,0,.64-.24.5.5,0,0,1,.43.9,5.08,5.08,0,0,1-.8.3Zm-4.82-1.63a.5.5,0,0,1-.4-.2,5,5,0,0,1-.46-.73.5.5,0,0,1,.89-.46,3.93,3.93,0,0,0,.37.58.5.5,0,0,1-.4.8Zm7.3-.1a.5.5,0,0,1-.41-.79,4,4,0,0,0,.35-.59.5.5,0,1,1,.9.43,5,5,0,0,1-.44.74A.5.5,0,0,1,234.81,64.7Zm.83-2.91a.5.5,0,0,1-.5-.47,3.91,3.91,0,0,0-.1-.68.5.5,0,0,1,1-.23,4.92,4.92,0,0,1,.13.85.5.5,0,0,1-.47.53Zm-.91-2.93a.5.5,0,0,1-.49-.39,5,5,0,0,1-.11-.85.5.5,0,1,1,1,0,4,4,0,0,0,.09.68.5.5,0,0,1-.38.6Zm13-.59a.5.5,0,0,1-.05-1,4,4,0,0,0,.67-.13.5.5,0,0,1,.28,1,5,5,0,0,1-.84.17Zm-2.27-.33a.5.5,0,0,1-.2,0,5.09,5.09,0,0,1-.76-.4.5.5,0,1,1,.54-.84,4,4,0,0,0,.61.32.5.5,0,0,1-.2,1Zm5-1a.5.5,0,0,1-.36-.85,4.06,4.06,0,0,0,.44-.53.5.5,0,0,1,.82.57,5.06,5.06,0,0,1-.55.66A.5.5,0,0,1,250.44,56.95Zm-7.25-1.08a.46.46,0,0,1-.4-.23.61.61,0,0,1-.07-.19,4.08,4.08,0,0,0-.27-.43.5.5,0,1,1,.81-.59,5.1,5.1,0,0,1,.4.65.5.5,0,0,1,0,.37.49.49,0,0,1-.24.35A.52.52,0,0,1,243.18,55.87Zm-8.05,0a.5.5,0,0,1-.45-.72,4.93,4.93,0,0,1,.45-.73.5.5,0,1,1,.8.6,4.07,4.07,0,0,0-.36.58A.5.5,0,0,1,235.13,55.85Zm16.6-1.65h0a.5.5,0,0,1-.45-.55,3.91,3.91,0,0,0,0-.4c0-.09,0-.19,0-.29a.5.5,0,0,1,.46-.53.51.51,0,0,1,.54.46c0,.12,0,.24,0,.36s0,.33,0,.5A.5.5,0,0,1,251.72,54.2Zm-10.66-.43a.5.5,0,0,1-.21,0,4,4,0,0,0-.64-.23.5.5,0,1,1,.26-1,5,5,0,0,1,.81.29.5.5,0,0,1-.21,1Zm-3.75,0a.5.5,0,0,1-.21-1,5,5,0,0,1,.81-.28.5.5,0,1,1,.25,1,4,4,0,0,0-.65.23A.5.5,0,0,1,237.32,53.76ZM251,51.24a.5.5,0,0,1-.46-.32,5,5,0,0,1-.25-.82.5.5,0,0,1,1-.2,3.93,3.93,0,0,0,.19.66.5.5,0,0,1-.28.65A.51.51,0,0,1,251,51.24Zm-.1-3-.15,0a.5.5,0,0,1-.33-.63,5.1,5.1,0,0,1,.33-.79.5.5,0,0,1,.89.46,4.07,4.07,0,0,0-.26.64A.5.5,0,0,1,250.94,48.21Zm8-1.26a.5.5,0,0,1-.41-.21,4,4,0,0,0-.44-.52.5.5,0,1,1,.71-.71,5,5,0,0,1,.55.65.5.5,0,0,1-.41.79Zm-6.18-1.15a.5.5,0,0,1-.27-.92l.45-.26.31-.15a.5.5,0,0,1,.4.92l-.24.11-.36.21A.5.5,0,0,1,252.77,45.79Zm3.7-.58-.13,0a4.06,4.06,0,0,0-.68-.13.5.5,0,0,1-.45-.55.51.51,0,0,1,.55-.45,5.09,5.09,0,0,1,.84.16.5.5,0,0,1-.13,1Z"
      fill="#4eb7f5"
    />
    <polygon
      points="257.49 23.06 254.56 22.16 253.66 19.22 252.76 22.16 249.83 23.06 252.76 23.95 253.66 26.89 254.56 23.95 257.49 23.06"
      fill="#a7e3fa"
    />
    <ellipse cx="239.48" cy="34.28" rx="1.8" ry="1.81" transform="translate(-0.26 1.85) rotate(-0.44)" fill="#a7e3fa" />
  </svg>
)
